import React from 'react';

const PerfilItem = (props) => {
    return (
        props.id != 0 &&
            <li className="inlineListItem right-separator-xxs">
                <div className="btn-group top-separator-xxxs no-margin-left">
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-left not-clickable">{props.codigo}</button>
                    <button type="button" className="btn-tag btn-tag-closable btn-tag-closable-right" onClick={() => props.deletePerfil(props.id)}>
                        <span key={props.key} className="ti-close span-closable color-white" title="Quitar perfil."></span>
                    </button>
                </div>
            </li>
    );
}

export default PerfilItem;